import PaginationData from "@/models/general/PaginationData";
import CustodyExpense from "./CustodyExpense";
import CustodyExpensesFilter from "./CustodyExpensesFilter";

export default class CustodyExpenses {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.status = 0;
    this.msg = "";
    this.pagination = new PaginationData();
    this.custodyExpensesData = [];
    this.custodyExpense = new CustodyExpense();
    this.filterData = new CustodyExpensesFilter();
  }
  fillData(data) {
    this.status = data.status;
    this.msg = data.msg;
    this.pagination.fillData(data.custodyExpensesPagination);
    this.custodyExpensesData =
      data.custodyExpensesPagination.custodyExpensesData;
  }
}
